__turbopack_context__.v({
  "blinker": "index-module-scss-module__wZbUgq__blinker",
  "button": "index-module-scss-module__wZbUgq__button",
  "inputError": "index-module-scss-module__wZbUgq__inputError",
  "waiting": "index-module-scss-module__wZbUgq__waiting",
});
